import { createFileRoute } from '@tanstack/react-router';
import { SensorMappingsPage } from '@/components/sensor-mappings';

export const Route = createFileRoute('/_authenticated/sensor-mappings')({
  component: SensorMappingsPage,
});
